import React from "react";

function MiniBar({ value, max, color }) {
  const pct = Math.min(100, Math.round((value / max) * 100));
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
      <div style={{
        width: 40, height: 4, background: "#f3f4f6", borderRadius: 2, overflow: "hidden"
      }}>
        <div style={{ width: `${pct}%`, height: "100%", background: color, borderRadius: 2 }} />
      </div>
      <span style={{ fontSize: 10, color: "#6b7280", width: 18, textAlign: "right" }}>{value}</span>
    </div>
  );
}

export default function ScoreBar({ score, trend, momentum, volume, structure, rr }) {
  const color = score >= 80 ? "#16a34a" : score >= 65 ? "#2563eb" : score >= 50 ? "#7c3aed" : "#9ca3af";
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <span style={{
        fontSize: 15, fontWeight: 700, color, minWidth: 28, fontFamily: "monospace"
      }}>{Math.round(score)}</span>
      <div style={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <MiniBar value={trend}     max={25} color="#2563eb" />
        <MiniBar value={momentum}  max={20} color="#7c3aed" />
        <MiniBar value={volume}    max={20} color="#0891b2" />
        <MiniBar value={structure} max={20} color="#65a30d" />
        <MiniBar value={rr}        max={15} color="#d97706" />
      </div>
    </div>
  );
}
